<template>
  <div class="mt-4 wrapper-table table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th class="text-center" scope="col"></th>
          <th scope="col">Ponto de Medição</th>
          <th scope="col">Ponto de Retaguarda</th>
          <th scope="col">ID Carga</th>
          <th scope="col">Identif. Carga CCEE</th>
          <th class="text-center">Ponto Ativo</th>
          <th class="text-center">Distribuidora</th>
          <th class="text-center">Cod. Un. Consumidora</th>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col"></th>
        </tr>
      </thead>
      <transition-group
        name="list"
        tag="tbody"
        mode="in-out"
        v-if="pontosDeMedicaoList && pontosDeMedicaoList.length > 0"
      >
        <tr
          v-for="(medicao, medicaoIndex) in pontosDeMedicaoList"
          :key="`medicao_${medicaoIndex}`"
          :class="{
            'recent-updated-row': recentUpdatedField(medicao.id),
            'inativado-lote-row': !medicao.ativoCadastro,
          }"
        >
          <td>
            <div class="pt-1 d-flex align-items-center justify-content-center">
              <tooltip
                v-if="recentUpdatedField(medicao.id)"
                :width="450"
                boxAlign="right"
                arrowAlign="right"
                icon="icon-warning"
              >
                <template #tooltip-text>
                  Possui informações alteradas recentemente, pendente de
                  aprovação
                </template>
              </tooltip>
            </div>
          </td>
          <td>{{ medicao.pontoMedicao || "-" }}</td>
          <td>{{ medicao.pontoRetaguarda || "-" }}</td>
          <td>{{ medicao.idCarga || "-" }}</td>
          <td>{{ medicao.identificacaoCargaCCEE || "-" }}</td>

          <td class="text-center">
            <i v-if="medicao.ativo" class="icon-check icon small" />
            <span v-else></span>
          </td>
          <td class="text-center">{{ getDistribuidoraByCode(medicao.codigoDistribuidoraAneel) }}</td>
          <td class="text-center">{{  medicao.codigoUnidadeConsumidora || "-" }}</td>
          <td>
            <i
              v-if="!disabled"
              class="icon-lapis cursop"
              @click="$emit('editPontoMedicao', medicao)"
            ></i>
          </td>
          <td>
            <i
              v-if="!disabled"
              class="icon-lixeira cursop"
              @click="$emit('deletePontoMedicao', medicao)"
            ></i>
          </td>
          <td class="text-center">
            <button
              v-if="!disabled && !medicao.ativoCadastro"
              type="button"
              class="btn-reativar"
              title="Reativar Unidade Consumidora inativada por inativação em lote"
              @click="$emit('reativarPontoMedicao', medicao)"
            >
              Reativar
            </button>
          </td>
        </tr>
      </transition-group>
      <tbody v-else>
        <tr>
          <td class="text-center" colspan="7">
            Nenhum ponto de medição cadastrado
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Tooltip from "@/components/Tooltip.vue";
export default {
  props: {
    distribuidoraList:Array,
    disabled: Boolean,
    pontosDeMedicaoList: {
      type: Array,
      required: false,
      default() {
        return new Array();
      },
    },
    recentUpdatedFields: {
      type: Array,
      required: false,
      default() {
        return new Array();
      },
    },
  },
  methods: {
    getDistribuidoraByCode(code){
        if(code){
          return this.distribuidoraList.find(g=>g.codigo_distribuidora === code)?.nome_distribuidora
        }
      return '-'
    },
    recentUpdatedField(pontoMedicaoId) {
      return this.recentUpdatedFields.find(
        (pontoMedicaoAlterado) => pontoMedicaoId === pontoMedicaoAlterado.id
      );
    },
  },
  components: {
    Tooltip,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/style.scss";
@import "@/assets/style/colors.scss";

.icon {
  color: $primary--orange !important;
}

th {
  font-weight: 500;
}

i {
  color: $primary--orange;
}

.inativado-lote-row {
  background-color: rgba($status--red, 0.08) !important;
}

.btn-reativar {
  border: 1px solid $secondary--blue;
  background-color: $primary--white;
  color: $secondary--blue;
  border-radius: 4px;
  font-size: 0.75rem;
  padding: 2px 8px;
  cursor: pointer;
  &:hover {
    background-color: $secondary--blue;
    color: $primary--white;
  }
}

.list-enter-active,
.list-leave-active {
  transition: opacity 0.3s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
}
</style>
